import { SchemaYellowHiveQuote } from 'wg-api-sdk';
import { create } from 'zustand';

interface FlowsProductYellowhiveSelectionStore {
  selectedYellowhiveItems: SchemaYellowHiveQuote[];
  addToYellowhiveSelected: (item: SchemaYellowHiveQuote) => void;
  removeFromYellowhiveSelected: (yellowhive_product_id: string) => void;
  replaceYellowhiveSelected: (item: SchemaYellowHiveQuote) => void;
  resetYellowhive: () => void;
}

const useYellowhiveFlowProductSelectionStore =
  create<FlowsProductYellowhiveSelectionStore>((set) => ({
    selectedYellowhiveItems: [],
    addToYellowhiveSelected: (item) =>
      set((state) => ({
        selectedYellowhiveItems: [...state.selectedYellowhiveItems, item],
      })),
    removeFromYellowhiveSelected: (yellowhive_product_id) =>
      set((state) => ({
        selectedYellowhiveItems: state.selectedYellowhiveItems.filter(
          (item) => item.yellowhive_product_id !== yellowhive_product_id,
        ),
      })),
    replaceYellowhiveSelected: (item) =>
      set((state) => ({
        selectedYellowhiveItems: state.selectedYellowhiveItems.map((oldItem) =>
          item.yellowhive_product_id === oldItem.yellowhive_product_id
            ? item
            : oldItem,
        ),
      })),
    resetYellowhive: () =>
      set(() => ({
        selectedYellowhiveItems: [],
      })),
  }));

export default useYellowhiveFlowProductSelectionStore;
